import React from 'react';
import _noop from 'lodash/noop';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiChip from '@material-ui/core/Chip';

const useStyles = (backgroundColor) => makeStyles((theme) => {
  let root = {};
  let icon = {};
  let deleteIcon = {};
  if (backgroundColor) {
    root = {
      ...root,
      backgroundColor,
      color: theme.palette.primary.contrastText,
    };
    icon = {
      ...icon,
      color: theme.palette.primary.contrastText,
    };
    deleteIcon = {
      ...deleteIcon,
      color: theme.palette.primary.contrastText,
    };
  }
  return { root, icon, deleteIcon };
});

const Chip = ({
  icon, label, backgroundColor, size, actionIcon, onClick, width,
}) => {
  const classes = useStyles(backgroundColor)();
  // Components props
  let chipProps = {
    icon, label, size, onClick, width,
  };

  if (actionIcon) {
    chipProps = {
      ...chipProps,
      onDelete: _noop,
      deleteIcon: actionIcon,
    };
  }

  return (
    <MuiChip {...chipProps} classes={classes} style={{ width }} />
  );
};

Chip.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  backgroundColor: PropTypes.string,
  size: PropTypes.string,
  actionIcon: PropTypes.element,
  onClick: PropTypes.func,
  width: PropTypes.string,
};

Chip.defaultProps = {
  icon: null,
  backgroundColor: null,
  size: 'small',
  actionIcon: null,
  onClick: null,
  width: null,
};

export default React.memo(Chip);



// WEBPACK FOOTER //
// ./components/core/Chip.js